import { createContext } from 'react';

export const initialState = {
  lang: 'de',
  activeMediaSrc: null,
};

export const Context = createContext(null);
